<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    height="24"
    width="24"
    viewBox="0 0 20 15.2"
    style="enable-background:new 0 0 20 15.2;"
    xml:space="preserve"
  >
    <g id="a" />
    <g id="b">
      <g id="c">
        <g
          id="d"
          transform="translate(-17.999 -225.995)"
        >
          <path
            id="e"
            class="icon-fill"
            d="M28,239.3l-8.4-5.1l-1.6,0.9l10,6l10-6l-1.6-0.9L28,239.3L28,239.3z"
          />
          <path
            id="f"
            class="icon-fill"
            d="M28,226l-9.6,5.8l1.1,0.7l0.3,0.2l0.3,0.2l1.1,0.7l0.3,0.2l0.3,0.2l6.3,3.8l6.3-3.8l0.3-0.2l0.2-0.2
          l1.1-0.7l0.5-0.3l1.1-0.7L28,226z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LayersIcon',
};
</script>
